import { render } from "./CardInset.vue?vue&type=template&id=51dbdaa7"
const script = {}

import exportComponent from "/Users/akrug/Sites/RetirePath/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__